<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-row v-if="apiError">
            <b-col>
                <b-alert variant="warning" show>{{apiError}}</b-alert>
            </b-col>
        </b-row>
        <spinner v-if="busy"></spinner>
        <b-row v-else>
            <b-col>
                <b-button class="float-right mb-2" v-b-modal.pageModal @click.stop="setNewPage()">
                    <i class="fal fa-plus"></i> New
                </b-button>
                <b-table responsive striped hover small :items="pageList"
                         :fields="['id', 'label', { key: 'actions', class: 'table-action-column' }]">
                    <template v-slot:cell(actions)="row">
                        <b-button variant="link" v-b-modal.pageModal @click.stop="openEditModal(row.item)">
                            <i class="fal fa-edit"></i></b-button>
                        <b-button variant="link" @click="deletePage(row.item.id)">
                            <i class="fal fa-trash-alt"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <page-modal
                @saved="loadPageList"
                ref="pageModal"
                id="pageModal">
        </page-modal>
    </b-container>
</template>

<script>

    import ContentAPI from "@shared/_api/cms/content";
    import PageModal from "./PageModal";
    import Spinner from "../../../viewsShop/components/ui/Spinner";

    export default {
        name: 'Template',
        props: {
            id: String
        },
        components: {
            "page-modal": PageModal,
            'spinner': Spinner
        },
        data() {
            return {
                busy: false,
                apiError: null,
                pageList: []
            };
        },
        methods: {
            loadPageList: function () {
                this.busy = true;
                ContentAPI.fetchPageList().then(pageList => {
                    this.pageList = pageList
                }).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                })

            },
            deletePage(pageId) {
                this.busy = true;
                ContentAPI.delete(pageId).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                    this.loadPageList();
                });
            },
            openEditModal(page) {
                this.$refs.pageModal.manageEntity(page);
            },
            setNewPage() {
                this.$refs.pageModal.manageEntity();
            }
        },
        created() {
            this.loadPageList();
        }
    }

</script>